var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgResizeAll(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.369 5.701c-.15 0-.31-.06-.42-.18l-1.98-1.972V11.4h7.87l-1.99-1.99a.61.61 0 010-.85.6.6 0 01.85 0l3 3c.14.14.195.336.164.522a.602.602 0 01-.23.394L19.7 15.41c-.12.13-.28.19-.43.19-.15 0-.31-.06-.42-.18a.61.61 0 010-.85l1.97-1.97h-7.85v7.86l1.99-1.99a.61.61 0 01.85 0 .6.6 0 010 .85l-3 3a.694.694 0 01-.217.137.595.595 0 01-.7-.194l-2.943-2.943a.61.61 0 010-.85.6.6 0 01.85 0l1.97 1.97v-7.84h-7.85l1.98 1.98c.23.23.23.61 0 .85a.65.65 0 01-.43.17c-.15 0-.31-.06-.42-.18l-2.944-2.943a.6.6 0 01-.056-.907l3-3a.61.61 0 01.85 0 .6.6 0 010 .85l-1.98 1.98h7.85V3.55l-1.98 1.972a.61.61 0 01-.85 0 .6.6 0 010-.85l3-3a.61.61 0 01.85 0l3 3c.23.23.23.61 0 .85-.11.12-.27.18-.42.18z"
  })));
}

export default SvgResizeAll;